"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _gx = require("@kyruus/gx");
var _propTypes = require("prop-types");
var _xstate = require("xstate");
var _react2 = require("@xstate/react");
var _framerMotion = require("framer-motion");
var _intl = require("@kyruus/intl");
var _appointmentInfo = require("@kyruus/appointment-info");
var _messages = _interopRequireDefault(require("../../lib/messages"));
var _useWindowWidth = _interopRequireDefault(require("../../lib/useWindowWidth"));
var _VisitTypes = require("../../lib/constants/VisitTypes");
var _States = require("../../lib/constants/States");
var _Actions = require("../../lib/constants/Actions");
var _styles = require("./styles");
var _utils = require("../../lib/utils");
var _configUtils = require("../../lib/configUtils");
var _Banners = require("../Banners");
var _NextBtn = _interopRequireDefault(require("./NextBtn"));
var _Recaptcha = require("../Recaptcha");
var _EmergencyDisclaimer = _interopRequireDefault(require("./EmergencyDisclaimer"));
var _Tracking = require("../../lib/constants/Tracking");
var _MountScroller = _interopRequireDefault(require("../Util/MountScroller"));
var _gxHandlers = require("./gx-handlers");
var _NextLoader = _interopRequireDefault(require("./NextLoader"));
var _RecaptchaErrorModal = _interopRequireDefault(require("../Recaptcha/RecaptchaErrorModal"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @param {StateNode} state
 * @returns {Object} empty object or object contiaining <eventName, eventData>
 */
const getTrackingByState = state => {
  const states = {
    [`${_States.apptQuestions}.${_States.apptPatientRel}.${_States.noAvailability}`]: () => ({
      eventName: _Tracking.pageEvents.APPOINTMENT_REASON,
      eventData: {
        mode: _Tracking.appointmentPurposeModes.NO_AVAIL_PATIENT_REL_ERR
      }
    }),
    [`${_States.apptQuestions}.${_States.apptPurpose}.${_States.noAvailability}`]: () => ({
      eventName: _Tracking.pageEvents.APPOINTMENT_REASON,
      eventData: {
        mode: _Tracking.appointmentPurposeModes.NO_AVAIL_PURPOSES_ERR
      }
    }),
    [`${_States.apptQuestions}.${_States.apptPurpose}.${_States.noResults}`]: () => ({
      eventName: _Tracking.pageEvents.APPOINTMENT_REASON,
      eventData: {
        mode: _Tracking.appointmentPurposeModes.NO_PURPOSES_ERR
      }
    }),
    [`${_States.apptQuestions}.${_States.apptPurpose}.${_States.idle}`]: () => ({
      eventName: _Tracking.pageEvents.APPOINTMENT_REASON,
      eventData: {
        mode: _Tracking.appointmentPurposeModes.PURPOSES_DROPDOWN
      }
    })
  };
  for (const key in states) {
    if (state.matches(key)) {
      return states[key]();
    }
  }
  return {};
};

/**
 * Appt purpose section should be visible if
 * - we're in any appt purpose state except for `noResults`
 * - we're in the conditionalGxQuestions state
 * - we're in the apptInfoComplete state
 * @param {StateNode} state
 * @returns {Boolean}
 */
const shouldShowApptPurpose = state => state.matches(`${_States.apptQuestions}.${_States.apptPurpose}`) && !state.matches(`${_States.apptQuestions}.${_States.apptPurpose}.${_States.noResults}`) || state.matches(`${_States.apptQuestions}.${_States.conditionalGxQuestions}`) || state.matches(`${_States.apptQuestions}.${_States.apptInfoComplete}`);
const shouldShowAppointmentInfo = state => state.matches(_States.apptQuestions) && !state.matches(`${_States.apptQuestions}.${_States.idle}`);

/**
 * Conditional GX questions should be visible if
 * - the AppointmentInfo component is visible
 * and if
 * - we're in the conditionalGxQuestions' conditionalApptGxV2Questions substate
 * or
 * - we're in the apptInfoComplete state and v2Conditionals is truthy
 * @param {StateNode} state
 * @param {Object} gx
 * @returns {Boolean}
 */
const shouldShowConditionalGxQuestions = (state, gx) => {
  return shouldShowAppointmentInfo(state) && (state.matches(`${_States.apptQuestions}.${_States.conditionalGxQuestions}.${_States.conditionalApptGxV2Questions}`) || state.matches(`${_States.apptQuestions}.${_States.apptInfoComplete}`) && gx.v2Conditionals);
};
const propTypes = {
  service: (0, _propTypes.instanceOf)(_xstate.Interpreter).isRequired,
  config: (0, _propTypes.shape)({
    emergency_disclaimer_md: (0, _propTypes.shape)({
      enabled: _propTypes.bool,
      markdown: (0, _propTypes.arrayOf)(_propTypes.string)
    }),
    emergency_disclaimer: (0, _propTypes.shape)({
      enabled: _propTypes.bool,
      text: _propTypes.string
    }),
    patient_type: (0, _propTypes.shape)({
      buttons: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
        button_text: _propTypes.string,
        patient_type: _propTypes.string
      }))
    }),
    recaptchaSiteKey: _propTypes.string
  }),
  track: _propTypes.func.isRequired,
  // supplied via `injectIntl`
  intl: (0, _propTypes.shape)({
    formatMessage: _propTypes.func.isRequired
  }),
  /* Properties for the appointment purpose filter controls */
  apptPurposeFilterProps: (0, _propTypes.shape)({
    /* Specifies the minimum number of appointment purposes before the filter controls are displayed */
    minPurposesForFilter: _propTypes.number,
    /* Labels for rendering the filter controls */
    labels: (0, _propTypes.shape)({
      noResultsLabel: _propTypes.string,
      purposeSearchLabel: _propTypes.string,
      purposeSearchPlaceholderLabel: _propTypes.string,
      visitTypeAllLabel: _propTypes.string,
      visitTypeInPersonLabel: _propTypes.string,
      visitTypeVirtualLabel: _propTypes.string
    }),
    /* Function executed when the name filter changes */
    onNameFilterChange: _propTypes.func,
    /* Function executed when the visit type filter changes */
    onVisitTypeFilterChange: _propTypes.func,
    /* Function executed when the filters are cleared */
    onClearFilters: _propTypes.func
  })
};
const ApptInfo = _ref => {
  let {
    service,
    config,
    track,
    intl,
    apptPurposeFilterProps
  } = _ref;
  const [state, send] = (0, _react2.useService)(service);
  const {
    provider,
    patientRel,
    purpose,
    csrfToken,
    purposeOptionsByRel,
    gx,
    hidePatientRel,
    customerCode
  } = state.context;
  const {
    aboveMd
  } = (0, _useWindowWidth.default)();
  (0, _react.useEffect)(() => {
    const {
      eventName,
      eventData = {}
    } = getTrackingByState(state);
    if (eventName) {
      track(eventName, eventData);
    }
  }, [state, track]);

  // NOTE: eslint complains because it wants an `inline` function to be passed into `useCallback`
  // since it can't tell what the internal function depends on
  /*eslint-disable react-hooks/exhaustive-deps*/
  const handleGxChange = (0, _react.useCallback)((0, _gxHandlers.getHandleGxChange)({
    send,
    track,
    event: _Actions.GX_QUESTION_ANSWERED
  }), [send, track]);
  const handleGxDone = (0, _react.useCallback)((0, _gxHandlers.getHandleGxDone)({
    send,
    track,
    event: _Actions.GX_PASSED
  }), [send, track]);
  const handleGxV1Done = (0, _react.useCallback)((0, _gxHandlers.getHandleGxV1Done)({
    send,
    track
  }), [send, track]);
  const handleConditionalGxChange = (0, _react.useCallback)((0, _gxHandlers.getHandleGxChange)({
    send,
    track,
    event: _Actions.CONDITIONAL_GX_QUESTION_ANSWERED
  }), [send, track]);
  const handleConditionalGxDone = (0, _react.useCallback)((0, _gxHandlers.getHandleGxDone)({
    send,
    track,
    event: _Actions.CONDITIONAL_GX_PASSED
  }), [send, track]);
  /*eslint-enable react-hooks/exhaustive-deps*/

  const handleClickNext = () => {
    track(_Tracking.userEvents.APPT_INFO_NEXT, {
      patient_rel: patientRel,
      purpose: purpose.name
    });
    send(_Actions.NEXT);
  };
  const handleCaptchaVerified = isCaptchaVerified => {
    send({
      type: _Actions.CAPTCHA_VERIFIED,
      data: isCaptchaVerified
    });
  };
  const handleCaptchaCancelled = () => {
    send(_Actions.CAPTCHA_CANCELLED);
  };
  const handleCaptchaError = () => {
    send(_Actions.CAPTCHA_ERROR);
  };
  const handleCaptchaReset = () => {
    send(_Actions.CAPTCHA_RESET);
  };
  const handleSelectPurpose = purpose => {
    track(_Tracking.userEvents.SET_PURPOSE, {
      patient_rel: patientRel,
      purpose: purpose.name
    });
    send({
      type: _Actions.SET_APPT_PURPOSE,
      data: {
        purpose: {
          name: purpose.name,
          visit_method: purpose.visit_method
        }
      }
    });
  };
  /**
   * Setting phone to empty string here will take care of displaying an alternate banner without a phone number.
   */
  const phone = (0, _configUtils.shouldHideSchedulingHelpMessages)(config) ? '' : (0, _utils.getMainContactNumber)(provider);
  const providerName = (0, _utils.formatProviderName)(provider);
  const providerLocationStateFullName = (0, _utils.getProviderLocationStateFullName)(provider);
  if (state.matches(_States.error) || state.matches(`${_States.apptQuestions}.${_States.conditionalGxQuestions}.${_States.error}`)) {
    return /*#__PURE__*/_react.default.createElement(_styles.Container, null, /*#__PURE__*/_react.default.createElement(_Banners.ErrorBookingBanner, {
      phone: phone
    }));
  }
  const apptInfoFormName = 'appointment-info';

  // customers with read-only Availability will not have a DBW config
  // instead use application string templates
  const appointmentInfoButtonConfig = config.patient_type?.buttons?.length > 0 ? config.patient_type.buttons : [{
    patient_type: 'new',
    button_text: intl.formatMessage(_messages.default.newPatientButtonText)
  }, {
    patient_type: 'existing',
    button_text: intl.formatMessage(_messages.default.existingPatientButtonText)
  }];
  return /*#__PURE__*/_react.default.createElement(_styles.Container, {
    "data-testid": "ApptInfo"
  }, /*#__PURE__*/_react.default.createElement(_EmergencyDisclaimer.default, {
    config: config,
    onClose: () => {
      track('user_action.direct_book.appt_info.emergency_warning.close_warning');
    },
    onClick: event => {
      if (event.target && event.target.href) {
        track('user_action.direct_book.appt_info.emergency_warning.warning_link');
      }
    }
  }), state.matches(`${_States.gxQuestions}.${_States.apptGxQuestions}`) && /*#__PURE__*/_react.default.createElement(_styles.GxQuestions, null, /*#__PURE__*/_react.default.createElement(_gx.GxUi, {
    name: gx.v1.name,
    animateInitial: true,
    machine: _gx.GxEngine.createMachine({
      config: gx.v1.config
    }),
    onDone: handleGxV1Done,
    onChange: handleGxChange
  }), state.matches(`${_States.gxQuestions}.${_States.apptGxQuestions}.${_States.failedGxV1}`) && /*#__PURE__*/_react.default.createElement(_Banners.UnavailableToScheduleBanner, {
    phone: phone
  })), state.matches(`${_States.gxQuestions}.${_States.apptGxV2Questions}`) && /*#__PURE__*/_react.default.createElement(_styles.GxQuestions, {
    "data-testid": "GxQuestions"
  }, /*#__PURE__*/_react.default.createElement(_styles.GxNextQuestions, {
    templateVariables: {
      provider_name: providerName,
      provider_state: providerLocationStateFullName,
      phone_number: phone
    },
    csrfToken: csrfToken,
    name: gx.v2.name,
    steps: [gx.v2],
    providerId: provider.id,
    onChange: handleGxChange,
    onDone: handleGxDone,
    catchAllErrorBanner: /*#__PURE__*/_react.default.createElement(_Banners.ErrorBookingBanner, {
      phone: phone
    })
    // NOTE: XState does not update GxNextQuestions machine with updated React props.
    // The result is we do not need to clear out gx.contextualInfo updated by setConditionalGxContext for GxConditionalQuestions
    ,
    externalContext: gx.contextualInfo.context
  })), shouldShowAppointmentInfo(state) && /*#__PURE__*/_react.default.createElement(_appointmentInfo.AppointmentInfo, {
    patientRelTitle: /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default.patientRelTitle, {
      values: {
        display_name: providerName
      }
    })),
    buttonConfig: appointmentInfoButtonConfig,
    onPatientRelSelect: patientRel => {
      track(_Tracking.userEvents.SET_PATIENT_REL, {
        patient_rel: patientRel
      });
      send({
        type: _Actions.SET_PATIENT_REL,
        data: {
          patientRel
        }
      });
    },
    patientRel: patientRel,
    apptPurposeTitle: /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.appointmentPurposeTitle),
    purposeOptionsByRel: purposeOptionsByRel,
    showNoBooking: state.matches(`${_States.apptQuestions}.${_States.apptPatientRel}.${_States.noAvailability}`),
    NoBookingBanner: () => /*#__PURE__*/_react.default.createElement(_Banners.NoOnlineBookingBanner, {
      providerName: providerName,
      patientRel: patientRel,
      phone: phone
    }),
    hidePatientRel: hidePatientRel,
    showPurpose: shouldShowApptPurpose(state),
    purpose: purpose,
    onSelectPurpose: purpose => handleSelectPurpose(purpose),
    virtualVisitConfig: {
      [_VisitTypes.PHONE]: intl.formatMessage(_messages.default.appointmentPhoneTitle),
      [_VisitTypes.VIDEO]: intl.formatMessage(_messages.default.appointmentVideoTitle),
      [_VisitTypes.IN_PERSON]: intl.formatMessage(_messages.default.appointmentInPersonTitle)
    },
    apptPurposeFilterProps: apptPurposeFilterProps,
    formName: apptInfoFormName
  }), shouldShowConditionalGxQuestions(state, gx) && /*#__PURE__*/_react.default.createElement(_styles.GxConditionalQuestions, {
    "data-testid": "ConditionalGxQuestions"
  }, /*#__PURE__*/_react.default.createElement(_styles.GxNextQuestions, {
    templateVariables: {
      provider_name: providerName,
      provider_state: providerLocationStateFullName,
      phone_number: phone
    },
    csrfToken: csrfToken,
    name: gx.v2Conditionals.name,
    steps: [gx.v2Conditionals],
    providerId: provider.id,
    onChange: handleConditionalGxChange,
    onDone: handleConditionalGxDone,
    catchAllErrorBanner: /*#__PURE__*/_react.default.createElement(_Banners.ErrorBookingBanner, {
      phone: phone
    }),
    externalContext: gx.contextualInfo.context
  })), !aboveMd && phone && /*#__PURE__*/_react.default.createElement(_Banners.SchedulingHelpBanner, {
    phone: phone,
    track: track
  }), (state.matches(`${_States.apptQuestions}.${_States.apptPurpose}.${_States.noAvailability}`) || state.matches(`${_States.apptQuestions}.${_States.apptPurpose}.${_States.noResults}`)) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_Banners.NoOnlineBookingBanner, {
    providerName: providerName,
    patientRel: patientRel,
    phone: phone,
    "data-testid": "ApptPurposeUnavailableBanner"
  })), state.matches(`${_States.apptQuestions}.${_States.conditionalGxQuestions}.${_States.pending}`) && /*#__PURE__*/_react.default.createElement(_NextLoader.default, null), /*#__PURE__*/_react.default.createElement(_framerMotion.AnimatePresence, null, state.matches(`${_States.apptQuestions}.${_States.apptInfoComplete}.${_States.idle}`) && /*#__PURE__*/_react.default.createElement(_MountScroller.default, {
    alignToTop: (0, _configUtils.isDirectBookRenderedInDrawer)(config),
    delay: 120
  }, ref => {
    return /*#__PURE__*/_react.default.createElement(_NextBtn.default, {
      ref: ref,
      onClick: handleClickNext,
      type: "submit",
      form: apptInfoFormName
    });
  })), state.matches(`${_States.apptQuestions}.${_States.apptInfoComplete}.${_States.verifyingCaptcha}`) && /*#__PURE__*/_react.default.createElement(_Recaptcha.RecaptchaModal, {
    onCancel: handleCaptchaCancelled,
    onError: handleCaptchaError,
    onVerified: handleCaptchaVerified,
    siteKey: config.recaptchaSiteKey,
    customerCode: customerCode
  }), state.matches(`${_States.apptQuestions}.${_States.apptInfoComplete}.${_States.verifyingCaptchaError}`) && /*#__PURE__*/_react.default.createElement(_RecaptchaErrorModal.default, {
    onClose: handleCaptchaCancelled,
    onReset: handleCaptchaReset
  }));
};
ApptInfo.propTypes = propTypes;
var _default = exports.default = (0, _intl.injectIntl)(ApptInfo);
ApptInfo.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ApptInfo",
  "props": {
    "service": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "Interpreter"
      },
      "required": true
    },
    "config": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "emergency_disclaimer_md": {
            "name": "shape",
            "value": {
              "enabled": {
                "name": "bool",
                "required": false
              },
              "markdown": {
                "name": "arrayOf",
                "value": {
                  "name": "string"
                },
                "required": false
              }
            },
            "required": false
          },
          "emergency_disclaimer": {
            "name": "shape",
            "value": {
              "enabled": {
                "name": "bool",
                "required": false
              },
              "text": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "patient_type": {
            "name": "shape",
            "value": {
              "buttons": {
                "name": "arrayOf",
                "value": {
                  "name": "shape",
                  "value": {
                    "button_text": {
                      "name": "string",
                      "required": false
                    },
                    "patient_type": {
                      "name": "string",
                      "required": false
                    }
                  }
                },
                "required": false
              }
            },
            "required": false
          },
          "recaptchaSiteKey": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "intl": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "formatMessage": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": false
    },
    "apptPurposeFilterProps": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "minPurposesForFilter": {
            "name": "number",
            "required": false
          },
          "labels": {
            "name": "shape",
            "value": {
              "noResultsLabel": {
                "name": "string",
                "required": false
              },
              "purposeSearchLabel": {
                "name": "string",
                "required": false
              },
              "purposeSearchPlaceholderLabel": {
                "name": "string",
                "required": false
              },
              "visitTypeAllLabel": {
                "name": "string",
                "required": false
              },
              "visitTypeInPersonLabel": {
                "name": "string",
                "required": false
              },
              "visitTypeVirtualLabel": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "onNameFilterChange": {
            "name": "func",
            "required": false
          },
          "onVisitTypeFilterChange": {
            "name": "func",
            "required": false
          },
          "onClearFilters": {
            "name": "func",
            "required": false
          }
        }
      },
      "required": false
    }
  }
};